import { createEffect, createEvent } from 'effector'

import {
  AuthAPI,
  PostLoginReq,
  PostLoginSendCodeReq,
  PostLoginTypeReq,
  PostRecoveryReq,
  PostRecoverySendCodeReq,
  PostRecoveryValidateReq,
  PostRegReq,
  PostRegSendCodeReq,
  PostRegValidateReq,
} from '../../services/api/Auth'
import { APIResult, AxiosError } from '../../core/api/Result'
import { AuthParams } from '../../shared/enum'
import { localStorage } from '../../utils'
import { $cashQuery, setCashQueryFx } from '../Init/store'

export const $setAuthToken = createEvent<string>()
export const $setPhone = createEvent<string | undefined>()
export const $setEmail = createEvent<string | undefined>()
export const $setCode = createEvent<string>()
export const $loginClear = createEvent()
export const $loginSendCodeClear = createEvent()

export interface PostValidate extends PostRegValidateReq { context: 'phone' | 'email' | 'code' }
export const $postValidate = createEffect<PostValidate, APIResult<typeof AuthAPI['postRegStart']>, AxiosError>(
  AuthAPI.postRegStart,
)

export const $postLoginType = createEffect<PostLoginTypeReq, APIResult<typeof AuthAPI['postLoginType']>, AxiosError>(
  AuthAPI.postLoginType,
)

export const $postSendCode = createEffect<PostRegSendCodeReq, APIResult<typeof AuthAPI['postRegSendCode']>, AxiosError>(
  AuthAPI.postRegSendCode,
)

export const $postRegister = createEffect<PostRegReq, APIResult<typeof AuthAPI['postReg']>, AxiosError>((data) => {
  const cashQuery = $cashQuery.getState()
  const invitedUserId = cashQuery[AuthParams.INVITE_ID] || localStorage.get(AuthParams.INVITE_ID)
  localStorage.remove(AuthParams.INVITE_ID)
  setCashQueryFx({ [AuthParams.INVITE_ID]: null })
  return AuthAPI.postReg({ ...data, invitedUserId: invitedUserId ? invitedUserId : undefined })
})

export const $postLogin = createEffect<PostLoginReq, APIResult<typeof AuthAPI['postLogin']>, AxiosError>(
  AuthAPI.postLogin,
)

export const $postLoginSendCode = createEffect<PostLoginSendCodeReq, APIResult<typeof AuthAPI['postLoginSendCode']>, AxiosError>((data) => {
  $loginClear()
  return AuthAPI.postLoginSendCode(data)
})

export const $postRecoverySendCode = createEffect<PostRecoverySendCodeReq, APIResult<typeof AuthAPI['postRecoverySendCode']>, AxiosError>(
  AuthAPI.postRecoverySendCode,
)
export const $recoverySendCodeClear = createEvent()

export const $postRecovery = createEffect<PostRecoveryReq, APIResult<typeof AuthAPI['postRecovery']>, AxiosError>(
  AuthAPI.postRecovery,
)

export const $postRecoveryValidate = createEffect<PostRecoveryValidateReq, APIResult<typeof AuthAPI['postRecoveryValidate']>, AxiosError>(
  AuthAPI.postRecoveryValidate,
)

export const $getLoginRefreshFx = createEffect<unknown, APIResult<typeof AuthAPI['getLoginRefresh']>, AxiosError>(AuthAPI.getLoginRefresh)

export const $getLogoutFx = createEffect(AuthAPI.getLogout)
